const FOR = [
  "Advisors getting leads but not enough appointments",
  "Advisors inconsistent with follow-up",
  "Advisors who want automation but don't know where to start",
];

const NOT_FOR = [
  "Advisors looking for overnight success",
  "Advisors unwilling to follow a system",
  "Advisors not ready to invest in growth",
];

export default function WhoFor() {
  return (
    <section
      id="who-for"
      data-testid="who-for-section"
      className="relative py-20 sm:py-28"
    >
      <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="reveal text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-5">
            <span className="h-[1px] w-10 bg-amber-500/70" />
            <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
              Honest Fit Check
            </span>
            <span className="h-[1px] w-10 bg-amber-500/70" />
          </div>
          <h2
            data-testid="who-for-headline"
            className="font-display font-light text-white text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-[-0.01em] text-balance"
          >
            Is this <span className="italic text-amber-400">for you?</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* FOR */}
          <div
            data-testid="who-for-card"
            className="reveal relative bg-emerald-500/[0.05] border border-emerald-500/30 p-8 sm:p-10"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-full bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center text-emerald-400">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>
              <div className="font-sans-body uppercase text-[11px] tracking-[0.3em] text-emerald-400">
                This is for you if
              </div>
            </div>

            <ul className="space-y-4">
              {FOR.map((f, i) => (
                <li
                  key={f}
                  data-testid={`who-for-yes-${i}`}
                  className="flex items-start gap-3 text-base sm:text-lg text-white leading-snug"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    className="text-emerald-400 mt-1 shrink-0"
                  >
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* NOT FOR */}
          <div
            data-testid="who-not-for-card"
            className="reveal relative bg-rose-500/[0.04] border border-rose-500/25 p-8 sm:p-10"
            style={{ transitionDelay: "120ms" }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-full bg-rose-500/15 border border-rose-500/40 flex items-center justify-center text-rose-400">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M6 6l12 12M18 6L6 18" />
                </svg>
              </div>
              <div className="font-sans-body uppercase text-[11px] tracking-[0.3em] text-rose-400">
                This is NOT for you if
              </div>
            </div>

            <ul className="space-y-4">
              {NOT_FOR.map((f, i) => (
                <li
                  key={f}
                  data-testid={`who-not-for-${i}`}
                  className="flex items-start gap-3 text-base sm:text-lg text-slate-300 leading-snug"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    className="text-rose-400 mt-1 shrink-0"
                  >
                    <path d="M6 6l12 12M18 6L6 18" />
                  </svg>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
